module.exports = "/_next/static/images/Tyler_Duclos-f75acdc5641a19ef7b2ed956ba664374.webp";